// extracted by mini-css-extract-plugin
export default {"productDescription":"Gca-z","featuredDescription":"Hca-z","description":"Ica-z","more":"Jca-z","descriptionSku":"Kca-z"};